import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import Icon from 'src/common/components/icons/Icon';
import TicketCard from 'src/common/components/styled/TicketCard';
import { LanguageKeys } from 'src/common/constants/languages';
import { ICompetition } from 'src/interfaces/Competition';

interface Props {
  competition: ICompetition;
  finisherCount: number;
  currentLang: LanguageKeys;
  year: number;
  getCompetitionLink: (competitionName: string, year: number) => string;
}

export default function CompetitionInsightCard({
  competition,
  finisherCount,
  currentLang,
  year,
  getCompetitionLink,
}: Props) {
  const { t } = useTranslation();
  const competitionName = competition.i18n[currentLang];
  const finisherLabel = t('insights.competitionCard.finishers', { count: finisherCount });

  return (
    <Box
      component={RouterLink}
      to={getCompetitionLink(competition.name, year)}
      sx={{ textDecoration: 'none', color: 'inherit', height: '100%', display: 'block' }}
    >
      <TicketCard
        eyebrow={t('drawer.insights')}
        title={competitionName}
        avatar={
          <Icon icon={competition.icon} fontSize="large" sx={{ width: '100%', height: '100%' }} />
        }
        badges={[{ label: finisherLabel, highlighted: true }]}
        sx={{ height: '100%' }}
      />
    </Box>
  );
}
